export const MARKETING = 'MARKETING';
export const SALES = 'SALES';
export const CUSTOMER_SERVICE = 'CUSTOMER_SERVICE';
export const PRODUCTIVITY = 'PRODUCTIVITY';
export const FINANCE = 'FINANCE';